















import { Prop, Component, Vue } from 'vue-property-decorator'

@Component
export default class PipelineTabPhase extends Vue {
    @Prop({ required: true }) readonly title!: string
    @Prop({ required: true }) readonly count!: number
    @Prop({ required: true }) readonly countBackgroundColor!: string
    @Prop({ required: true }) readonly countColor!: string
    @Prop({ default: false }) readonly active!: boolean

    onClick(): void {
        if (this.active) {
            return
        }

        this.$emit('activate', arguments)
    }

    get componentClasses(): {[key: string]: boolean} {
        return {
            'referral-list-tab--active': this.active,
        }
    }

    get countStyles(): {[key: string]: string} {
        return {
            'background-color': this.countBackgroundColor,
            'color': this.countColor,
        }
    }
}
